import React, {useEffect, useRef, useState} from 'react'
import SplitIcon from "../../../../../../assets/icons/SplitIcon";
import colors from "../../../../../../utils/Colors";
import Input from "../../../../../../components-new/form/Input";
import EditButton from "../../../../../../components-new/buttons/actions/EditButton";
import SilverButton from "../../../../../../components-new/buttons/SilverButton";
import CheckIcon from "../../../../../../assets/icons/CheckIcon";
import XIcon from "../../../../../../assets/icons/XIcon";

const NodeEditorHeader = ({nodeName, updateName, onClose}) => {

    const [name, setName] = useState(nodeName);
    const [nameBackup, setNameBackup] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const inputRef = useRef(null);

    useEffect(() => {
        setName(nodeName);
    }, [nodeName]);

    useEffect(() => {
        if (isEditing) {
            setNameBackup(nodeName);
        }
    }, [isEditing]);

    const isEditingRef = useRef(isEditing);

    useEffect(() => {
        isEditingRef.current = isEditing;
    }, [isEditing]);

    return (
        <header className="node-editor-header">
            <SilverButton
                onClick={onClose}
                variant="ghost"
                styles={{
                    width: '40px',
                    height: '40px',
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: '4px',
                    flexShrink: 0,
                }}
            >
                <XIcon width={24} height={24} style={{color: colors.silverBlue}} stroke="currentColor"/>
            </SilverButton>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: '10px',
                    flexGrow: 1,
                }}>
                <Input
                    value={name}
                    disabled={!isEditing}
                    ref={inputRef}
                    onChange={e => setName(e.target.value)}
                    onBlur={e => {
                        const value = e.target.value;

                        setTimeout(() => {
                            if (!isEditingRef.current) return;
                            setName(value);
                            updateName(value);
                            setIsEditing(false);
                        }, 500);
                    }}

                    style={{
                        height: "40px",
                    }}
                    className={'node-editor-header-input' + (isEditing ? ' is-editing' : '')}
                />

                {
                    isEditing ?
                        <SilverButton
                            width={'32px'}
                            height={'32px'}
                            onClick={() => {
                                setName(nameBackup);
                                setIsEditing(false);
                            }}
                            variant='outline'
                            styles={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: '4px',
                                flexShrink: 0,
                            }}
                        >
                            <XIcon width="18" height="18" style={{color: colors.silverDark}} stroke="currentColor"/>
                        </SilverButton>
                        :
                        <EditButton
                            variant='outline'
                            size={'xs'}
                            styles={{
                                flexShrink: 0,
                            }}
                            onClick={() => {
                                setIsEditing(true);
                                setTimeout(() => {
                                    inputRef.current && inputRef.current.focus();
                                }, 100)
                            }}
                        />
                }

            </div>
        </header>
    )
}

export default NodeEditorHeader


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/NodeEditor/NodeEditorHeader.jsx